import React, { PureComponent } from 'react'
import { Button, Modal, Row, FormGroup } from 'react-bootstrap'
import InputText from '../../../components/commons/form/InputText'
import { reduxForm, Field } from 'redux-form'
import { handleKeyDown } from '../../../util/utils'

class StoreCancelModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      buttonPressed: null,
      textValidation: '',
      openText: false,
      openButton: false
    }
  }

  submitStoreCancel (dossierId) {
    if (this.state.buttonPressed === 'store') {
      this.props.actions.storeDossier(dossierId, true, this.props.reset, true)
    } else if (this.state.buttonPressed === 'cancel') {
      this.props.actions.putCancelDossier(dossierId, true, this.props.reset, true)
    }
    this.props.closeStoreCancelModal()
  }

  selectOption (value, text) {
    this.setState({ buttonPressed: value, textValidation: text, openText: true, openButton: false })
    this.props.change('textValidation', '')
  }

  handleTextChange (value) {
    if (this.state.buttonPressed && this.state.textValidation && this.state.openText && value === this.state.textValidation) {
      this.setState({ openButton: true })
    } else {
      this.setState({ openButton: false })
    }
  }

  componentDidUpdate () {

  }

  getSnapshotBeforeUpdate (nextProps) {
    if (nextProps.showModal !== this.props.showModal) {
      this.setState({ buttonPressed: null, textValidation: '', openText: false, openButton: false })
      this.props.change('textValidation', '')
    }
    return null
  }

  render () {
    const {
      t, handleSubmit, showModal,
      dossierId
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.BUTTONS_HEADER.STORE_CANCEL_MODAL.'

    return (
      <Modal id='StoreCancelModal' className="_nf selectVoCompany-modal" show={showModal} onHide={this.props.closeStoreCancelModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitStoreCancel.bind(this, dossierId))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.closeStoreCancelModal}>
            <Modal.Title>{t(`${tKey + 'TITLE'}`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <div key={1} className="flexInLine complete">
                <Button
                  id="store"
                  className="_Btn accept stk"
                  type="button"
                  onClick={() => this.selectOption('store', t(`${tKey}STORE_BUTTON`))}>
                  <i className="iDocIcon-archive" />{t(`${tKey}STORE_BUTTON`)}
                </Button>
                <Button
                  id="cancel"
                  className="_Btn cancel"
                  type="button"
                  onClick={() => this.selectOption('cancel', t(`${tKey}CANCEL_BUTTON`))}>
                  <i className="iDocIcon-delete-forever" />{t(`${tKey}CANCEL_BUTTON`)}
                </Button>
              </div>
              <br/><br/>
              <Row className='fieldsContainer' key={2}>
                <Field
                  component={InputText}
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  id="textValidation"
                  name="textValidation"
                  controlLabel={t(`${tKey}TEXT_VALIDATION`) + this.state.textValidation }
                  placeholder={t(`${tKey}TEXT_VALIDATION`) + this.state.textValidation }
                  disabled = {!this.state.openText}
                  onInputChange={(value) => this.handleTextChange(value)}
                />
              </Row>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <div className='flexInLine al-R'><Button
              id="recurrent-entity-modal-submit-button"
              className="_Btn accept"
              type="submit"
              disabled={!this.state.openButton}>
              {t(`${tKey + 'SUBMIT_BUTTON'}`)}
            </Button>
            </div>

          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'storeCancelModal'
})(StoreCancelModal)
